<template>
  <div class="editablePhoneVerification mt-5">
    <div class="flex-column">
      <div class="flex-row">
        <F2gIcon
          value="phone"
          class="icon mr-2"
          :stroke="$CONSTANTS.COLOUR.DARK_GRAY_1_F2G"
          :strokeWidth="3"
        />
        <div class="flex-row-between">
          <div class="flex-col-center">
            <div v-if="disabled">{{ phone }}</div>

            <div v-if="!disabled" class="flex-row">
              <PhoneNumber
                :phone="phone"
                :model="phoneNumber"
                :label="$t('common.newPhoneNumber')"
                :error-messages="phoneNumberErrors"
                :disabled="disabled"
                :validate="phoneNumberValidate"
                @input="
                  () => {
                    $v.phoneNumber.$touch();
                  }
                "
                @phoneNumber="
                  (phone) => {
                    phoneNumber = phone;
                  }
                "
                @blur="$v.phoneNumber.$touch()"
              />
            </div>
            <div
              v-if="phoneNumberErrors.length > 0 && !disabled"
              class="errorContainer text--sm"
            >
              {{ phoneNumberErrors[0] }}
            </div>
          </div>

          <!-- Acciones -->

          <div class="ml-2 flex-row">
            <!-- Edit / send -->
            <span v-if="disabled">
              <F2gIcon
                v-if="hover || !disabled"
                class="icon button-rounded"
                :value="iconValue"
                :class="editionStyle"
                @click="eventEdition"
                :stroke="colorPrimaryForHover"
                :strokeWidth="3"
                :width="disabled ? 20 : 24"
                :height="disabled ? 20 : 24"
              />
            </span>
          </div>
        </div>
      </div>

      <v-layout class="mb-4" wrap justify-start v-if="!disabled">
        <v-btn
          class="button-rounded mr-4"
          color="primary"
          @click="eventEdition"
          >{{ $t("common.confirm") }}</v-btn
        >
        <v-btn class="button-rounded" color="error" @click="eventCancel">{{
          $t("common.cancel")
        }}</v-btn>
      </v-layout>
    </div>

    <!-- Info Modal -->
    <modalBase
      v-if="showModal"
      :show="showModal"
      :showActions="false"
      :showClose="true"
      :title="$t('common.quickHelp')"
      :maxWidth="500"
      @close="() => (showModal = false)"
    >
      <template slot="body">
        <div class="flex-row px-2 mb-4">
          <div class="flex-col-start">
            <F2gIcon value="security-1" class="pt-1" />
          </div>
          <div class="ml-2 text">{{ $t("common.smsValidationSend") }}</div>
        </div>
      </template>
    </modalBase>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import countriesFunction from "@/flit2go-web-core/util/prefixes.js";
import { mapActions, mapGetters } from "vuex";
import ModalBase from "@/flit2go-web-core/components/modal-base.vue";
import PhoneNumber from "@/flit2go-web-core/components/ui/phone-number";

const correctLength = (value, vueData) => {
  let countryData = countriesFunction
    .prefixes()
    .find((item) => item.code == vueData.countryCode);
  return countryData.size.includes(value.replace(/ /g, "").length);
};
// const localPrefixes = (value, vueData) => {
//   let countryData = countriesFunction.prefixes().find(item => item.code == vueData.countryCode);

//   countryData.localPrefixes.length != 0 ?
//     (countryData.localPrefixes.findIndex(element => value.replace(/ /g,'').length >= element.toString().length &&
//   value.replace(/ /g,'').substring(0, element.toString().length) == element) > -1 ? true : false) : true;
// }
const numeric = (value) => !isNaN(value.replace(/ /g, ""));

export default {
  name: "editablePhoneVerification",
  components: { ModalBase, PhoneNumber },
  props: {
    phone: { required: false, type: String, default: "-" },
  },
  data: () => ({
    colorPrimaryForHover: null,
    countryCode: null,
    disabled: true,
    hover: true,
    phoneNumber: null,
    prefix: null,
    showModal: false,
    validationCode: null,
    phoneNumberValidate: false,
  }),
  mounted() {
    this.colorPrimaryForHover = this.ownerColors.ownerPrimaryColor;
  },
  computed: {
    ...mapGetters({
      ownerColors: "auth/getOwnerColors",
    }),
    phoneNumberErrors() {
      const errors = [];
      if (this.$v.phoneNumber.$dirty) {
        !this.$v.phoneNumber.required &&
          errors.push(this.$t("errors.required"));
        // !this.$v.phoneNumber.localPrefixes && errors.push(`${this.$t("correctLocalPrefixes")}`);
        !this.$v.phoneNumber.numeric && errors.push(this.$t("errors.numeric"));
        !this.$v.phoneNumber.correctLength &&
          errors.push(this.$t("errors.length"));
      }
      return errors;
    },
    editionStyle() {
      return this.disabled ? "editIcon" : "arrowIcon";
    },
    iconValue() {
      return this.disabled ? "edit" : "lined-arrow-right";
    },
  },

  validations: {
    phoneNumber: {
      correctLength,
      required,
      numeric,
      // localPrefixes
    },
  },
  methods: {
    ...mapActions({
      validateCodePhone: "auth/validatePhoneToken",
    }),

    eventEdition() {
      if (this.disabled) {
        this.disabled = false;
      } else if (this.phoneNumberErrors.length <= 0 && this.phoneNumber) {
        let payload = { phoneNumber: this.phoneNumber };
        this.validateCodePhone(payload)
          .then((resp) => {
            this.disabled = true;
            this.$emit("phoneChanged", resp.data);
          })
          .catch((err) => {
            this.$emit("errorChanging", err.response.data);
          });
      } else {
        this.phoneNumberValidate = true;
        setTimeout(() => {
          this.phoneNumberValidate = false;
        }, 300);
      }
    },
    eventCancel() {
      this.disabled = true;
    },
    eventInfo() {
      this.showModal = true;
    },
    eventSelectCountry(event) {
      this.prefix = event.dialCode;
      this.countryCode = event.iso2;
    },
  },
};
</script>

<style lang="scss">
.editablePhoneVerification {
  .icon {
    height: 28px;
    width: 28px;
    stroke: grey;
  }

  .mainIconHover {
    stroke: $success-f2g;
  }

  .editIcon {
    cursor: pointer;
    fill: $yellow-f2g;
  }

  .arrowIcon {
    cursor: pointer;
    stroke: $success-f2g;
    transition-duration: 500ms;
    transition-property: background-color;
  }
  .arrowIcon:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .cancelIcon {
    cursor: pointer;
    stroke: $red-error;
  }

  .cancelIcon:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .infoIcon:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .input {
    border-bottom: 2px solid $success-f2g;
  }

  .vue-country-select {
    border: 0;
    .dropdown {
      outline: none;
      padding: 0;
    }
    .country-code {
      padding-left: 4px;
      padding-right: 2px;
    }
  }
  .vue-country-select:focus-within {
    box-shadow: 0 0;
  }

  .errorContainer {
    position: absolute;
    color: $red-error;
    margin-top: 44px;
    margin-left: 61px;
  }
  .v-text-field {
    padding-top: 0;
    margin-top: 0;
  }
  .v-text-field input {
    padding: 8px 0 0;
  }
}
</style>
import { required } from "vuelidate/lib/validators";
